export default class GformHelper {
    constructor() {
        let self = this;
        const gFieldsSelector = '.ginput_container input[type="text"], ' +
                '.ginput_container input[type="email"], ' +
                '.ginput_container input[type="number"], ' +
                '.ginput_container input[type="url"], ' +
                '.ginput_container input[type="password"], ' +
                '.ginput_container textarea, ' +
                '.ginput_container select';

        $(document).on('focusin focusout', '.input-text', function (e) {
            self.toggleFocusedClass($(this), e.type);
        }).on('focusin focusout', gFieldsSelector, function (e) {
            self.toggleFocusedClass($(this), e.type, '.gfield');
        }).on('focusin focusout', '.cart-sticky-data .input-text', function (e) {
            self.toggleFocusedClass($(this), e.type, '.form-row');
        }).on('focusin focusout', '.configurator-step input, .configurator-step textarea', function (e) {
            self.toggleFocusedClass($(this), e.type, '.form-group');
        });
    }

    toggleFocusedClass($field, type, row = '.woocommerce-form-row') {
        let $row = $field.closest(row);

        if($row.length) {
            if(type === 'focusin') {
                $row.addClass('focused');
            }

            if(type === 'focusout') {
                $row.removeClass('focused');
            }
        }
    }
}